let isUpdating = false;
function handleGift() {
    const arrId = [document.querySelector('.gamification')?.getAttribute('gift-variant-1'),
        document.querySelector('.gamification')?.getAttribute('gift-variant-2'),
        document.querySelector('.gamification')?.getAttribute('gift-variant-3')]
    const filteredArr = arrId.filter(Boolean);
    const idFirstGift = filteredArr[0];
    const idSecondGift = filteredArr[1];
    const idThirdGift = filteredArr[2];
    const idFreeGift = document.querySelector('.gamification')?.getAttribute('free_gift_every_order');
    const idConditionalGift = document.querySelector('.gamification')?.getAttribute('conditional-gift-id');

    const firstGiftInCard = document.querySelector(`#CartDrawer tr[data-id="${idFirstGift}"]`);
    const secondGiftInCard = document.querySelector(`#CartDrawer tr[data-id="${idSecondGift}"]`);
    const thirdGiftInCard = document.querySelector(`#CartDrawer tr[data-id="${idThirdGift}"]`);
    const freeGiftInCard = document.querySelector(`#CartDrawer tr[data-id="${idFreeGift}"]`);
    const conditionalGiftInCard = document.querySelector(`#CartDrawer tr[data-id="${idConditionalGift}"]`);

    const arrAmount = [Number(document.querySelector('.gamification')?.dataset.amountOne),
    Number(document.querySelector('.gamification')?.dataset.amountTwo),
    Number(document.querySelector('.gamification')?.dataset.amountThree)]
    const filteredArrAmount = arrAmount.filter(Boolean);
    const firstGiftAmount = filteredArrAmount[0];
    const secondGiftAmount = filteredArrAmount[1];
    const thirdGiftAmount = filteredArrAmount[2];
    const conditionalGiftAmount = Number(document.querySelector('.gamification')?.dataset.conditionalThreshold);

    const localStorageData = localStorage.getItem('blockgift');
    const blockFistGift = localStorageData?.includes(idFirstGift);
    const blockSecondGift = localStorageData?.includes(idSecondGift);
    const blockThirdGift = localStorageData?.includes(idThirdGift);
    const blockFreeGift = localStorageData?.includes(idFreeGift);
    const blockConditionalGift = localStorageData?.includes(idConditionalGift);

    const valueCartCartPage = Number(document.querySelector('.cart__footer .totals__subtotal-value')?.dataset.total);
    const valueCartCartDrawer = Number(document.querySelector('.cart-drawer__footer .totals__subtotal')?.dataset.total);
    const totalAmount = document.querySelector('.cart__footer .totals__subtotal-value') ? valueCartCartPage : valueCartCartDrawer;
// console.log({idFirstGift, firstGiftAmount, firstGiftInCard, blockFistGift, totalAmount})
    if (idFirstGift && idSecondGift && idThirdGift && !firstGiftInCard && !secondGiftInCard && !thirdGiftInCard && !blockFistGift && !blockSecondGift && thirdGiftAmount && totalAmount >= thirdGiftAmount) {
        if(idFreeGift && !freeGiftInCard && !blockFreeGift && totalAmount >= 0) {
            this.addGift([
                {
                    id: parseInt(idFirstGift),
                    quantity: 1,
                    properties: { _gift: true }
                },
                {
                    id: parseInt(idSecondGift),
                    quantity: 1,
                    properties: { _gift: true }
                },
                {
                    id: parseInt(idThirdGift),
                    quantity: 1,
                    properties: { _gift: true }
                },
                {
                    id: parseInt(idFreeGift),
                    quantity: 1,
                    properties: { _gift: true }
                }
            ])
          } else {
            this.addGift([
                {
                    id: parseInt(idFirstGift),
                    quantity: 1,
                    properties: { _gift: true }
                },
                {
                    id: parseInt(idSecondGift),
                    quantity: 1,
                    properties: { _gift: true }
                },
                {
                    id: parseInt(idThirdGift),
                    quantity: 1,
                    properties: { _gift: true }
                }
            ])
          }
    } else if (idFirstGift && idSecondGift && !firstGiftInCard && !secondGiftInCard && !blockFistGift && !blockSecondGift && secondGiftAmount && totalAmount >= secondGiftAmount) {
        // add first two
        if(idFreeGift && !freeGiftInCard && !blockFreeGift && totalAmount >= 0) {
            this.addGift([
                {
                    id: parseInt(idFirstGift),
                    quantity: 1,
                    properties: { _gift: true }
                },
                {
                    id: parseInt(idSecondGift),
                    quantity: 1,
                    properties: { _gift: true }
                },
                {
                    id: parseInt(idFreeGift),
                    quantity: 1,
                    properties: { _gift: true }
                }
            ])
        } else {
            this.addGift([
                {
                    id: parseInt(idFirstGift),
                    quantity: 1,
                    properties: { _gift: true }
                },
                {
                    id: parseInt(idSecondGift),
                    quantity: 1,
                    properties: { _gift: true }
                }
            ])
        }

    } else if (idSecondGift && idThirdGift && !secondGiftInCard && !thirdGiftInCard && !blockSecondGift && thirdGiftAmount && totalAmount >= thirdGiftAmount) {
        // add first two
        if(idFreeGift && !freeGiftInCard && !blockFreeGift && totalAmount >= 0) {
            this.addGift([
                {
                    id: parseInt(idSecondGift),
                    quantity: 1,
                    properties: { _gift: true }
                },
                {
                    id: parseInt(idThirdGift),
                    quantity: 1,
                    properties: { _gift: true }
                },
                {
                    id: parseInt(idFreeGift),
                    quantity: 1,
                    properties: { _gift: true }
                }
            ])
        } else {
        this.addGift([
            {
                id: parseInt(idSecondGift),
                quantity: 1,
                properties: { _gift: true }
            },
            {
                id: parseInt(idThirdGift),
                quantity: 1,
                properties: { _gift: true }
            }
        ])
    }
    }else if (idFirstGift && !firstGiftInCard && !blockFistGift && firstGiftAmount && totalAmount >= firstGiftAmount) {
        //add first
        if(idFreeGift && !freeGiftInCard && !blockFreeGift && totalAmount >= 0) {
            this.addGift([
                {
                    id: parseInt(idFirstGift),
                    quantity: 1,
                    properties: { _gift: true }
                },
                {
                    id: parseInt(idFreeGift),
                    quantity: 1,
                    properties: { _gift: true }
                }
            ])
        } else {
            this.addGift([
                {
                    id: parseInt(idFirstGift),
                    quantity: 1,
                    properties: { _gift: true }
                }
            ])
        }

    } else if (idSecondGift && !secondGiftInCard && !blockSecondGift && secondGiftAmount && totalAmount >= secondGiftAmount) {
        //add second
        if(idFreeGift && !freeGiftInCard && !blockFreeGift && totalAmount >= 0) {
            this.addGift([
                {
                    id: parseInt(idSecondGift),
                    quantity: 1,
                    properties: { _gift: true }
                },
                {
                    id: parseInt(idFreeGift),
                    quantity: 1,
                    properties: { _gift: true }
                }
            ])
        } else{
            this.addGift([
                {
                    id: parseInt(idSecondGift),
                    quantity: 1,
                    properties: { _gift: true }
                }
            ])
        }

    } else if (idThirdGift && !thirdGiftInCard && !blockThirdGift && thirdGiftAmount && totalAmount >= thirdGiftAmount) {
        //add third
        if(idFreeGift && !freeGiftInCard && !blockFreeGift && totalAmount >= 0) {
            this.addGift([
                {
                    id: parseInt(idThirdGift),
                    quantity: 1,
                    properties: { _gift: true }
                },
                {
                    id: parseInt(idFreeGift),
                    quantity: 1,
                    properties: { _gift: true }
                }
            ])
        } else {
            this.addGift([
                {
                    id: parseInt(idThirdGift),
                    quantity: 1,
                    properties: { _gift: true }
                }
            ])
        }

    }else if (idFirstGift && idSecondGift && idThirdGift && firstGiftInCard && secondGiftInCard && thirdGiftInCard && totalAmount < firstGiftAmount) {
        // console.log('Rick -')
        //remove all
        if(idFreeGift && freeGiftInCard && totalAmount <= 0){
            this.updateGift({
                [parseInt(idFirstGift)]: 0,
                [parseInt(idSecondGift)]: 0,
                [parseInt(idThirdGift)]: 0,
                [parseInt(idFreeGift)]: 0,
            })
        } else {
            this.updateGift({
                [parseInt(idFirstGift)]: 0,
                [parseInt(idSecondGift)]: 0,
                [parseInt(idThirdGift)]: 0,
            })
        }

    } else if (idSecondGift && idThirdGift && secondGiftInCard && thirdGiftInCard && secondGiftAmount && totalAmount < secondGiftAmount) {
        //remove all
        if(idFreeGift && freeGiftInCard && totalAmount <= 0){
            this.updateGift({
                [parseInt(idSecondGift)]: 0,
                [parseInt(idThirdGift)]: 0,
                [parseInt(idFreeGift)]: 0,
            })
        } else {
            this.updateGift({
            [parseInt(idSecondGift)]: 0,
            [parseInt(idThirdGift)]: 0,
        })
    }
    }else if (idThirdGift && thirdGiftInCard && totalAmount < thirdGiftAmount && secondGiftAmount && totalAmount >= secondGiftAmount) {
        // remove third
        if(idFreeGift && freeGiftInCard && totalAmount <= 0){
            this.updateGift({
                [parseInt(idThirdGift)]: 0,
                [parseInt(idFreeGift)]: 0,
            })
        } else{
            this.updateGift({
                [parseInt(idThirdGift)]: 0,
            })
        }

    } else if (idSecondGift && secondGiftInCard && totalAmount < secondGiftAmount && firstGiftAmount && totalAmount >= firstGiftAmount) {
        // remove second
        if(idFreeGift && freeGiftInCard && totalAmount <= 0){
            this.updateGift({
                [parseInt(idSecondGift)]: 0,
                [parseInt(idFreeGift)]: 0,
            })
        } else {
            this.updateGift({
                [parseInt(idSecondGift)]: 0,
            })
        }

    } else if (idFirstGift && firstGiftInCard && firstGiftAmount && totalAmount < firstGiftAmount) {
        // remove first
        if(idFreeGift && freeGiftInCard && totalAmount <= 0){
            this.updateGift({
                [parseInt(idFirstGift)]: 0,
                [parseInt(idFreeGift)]: 0,
            })
        } else {
            this.updateGift({
                [parseInt(idFirstGift)]: 0,
            })
        }

    } else if (totalAmount < 2 && idFreeGift) {
        localStorage.setItem('blockgift', '');
    }else if (totalAmount < firstGiftAmount) {
        const newLocalStorage = localStorageData?.replace(idFirstGift, '');
        localStorage.setItem('blockgift', newLocalStorage);
    } else if (totalAmount < secondGiftAmount && totalAmount >= firstGiftAmount) {
        const newLocalStorage = localStorageData?.replace(idSecondGift, '');
        localStorage.setItem('blockgift', newLocalStorage);
    } else if (totalAmount < thirdGiftAmount && totalAmount >= firstGiftAmount) {
        const newLocalStorage = localStorageData?.replace(idThirdGift, '');
        localStorage.setItem('blockgift', newLocalStorage);
    }

    // Clear conditional gift blocking if conditions not met
    if (idConditionalGift && localStorageData?.includes(idConditionalGift)) {
        const hasVisitedFlag = window.PageVisitTracker?.hasVisited() || false;
        if (!hasVisitedFlag || totalAmount < conditionalGiftAmount) {
            const newLocalStorage = localStorageData?.replace(idConditionalGift, '');
            localStorage.setItem('blockgift', newLocalStorage);
        }
    }

    if(idFreeGift && !freeGiftInCard && !blockFreeGift && totalAmount > 0) {
        this.addGift([{
            id: parseInt(idFreeGift),
            quantity: 1,
            properties: { _gift: true }
        } ]);
      }

    if(idFreeGift && freeGiftInCard && totalAmount <= 0){
        // console.log('Rick - alleen free gift');
        // console.log({idFreeGift, freeGiftInCard, blockFreeGift, totalAmount})

        this.updateGift({
            [parseInt(idFreeGift)]: 0,
        })
      }

    // Conditional Gift Logic (Page Visit Flag based)
    if (idConditionalGift && conditionalGiftAmount && !conditionalGiftInCard && !blockConditionalGift) {
        // Check if user has visited tracked pages (Page Visit Flag)
        const hasVisitedFlag = window.PageVisitTracker?.hasVisited() || false;
        
        if (hasVisitedFlag && totalAmount >= conditionalGiftAmount) {
            console.log('[Gamification] Adding conditional gift for flagged user');
            this.addGift([{
                id: parseInt(idConditionalGift),
                quantity: 1,
                properties: { _gift: true, _conditional: true }
            }]);
        }
    }

    // Remove conditional gift if threshold not met or flag lost
    if (idConditionalGift && conditionalGiftInCard) {
        const hasVisitedFlag = window.PageVisitTracker?.hasVisited() || false;
        
        if (!hasVisitedFlag || totalAmount < conditionalGiftAmount) {
            console.log('[Gamification] Removing conditional gift - threshold not met or flag lost');
            this.updateGift({
                [parseInt(idConditionalGift)]: 0,
            });
        }
    }
}

function updateGift(items) {
    if(isUpdating) return;
    isUpdating = true;
    // update cart

    fetch('/cart/update.js', {
        body: JSON.stringify({
            updates: items,
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
        },
    })
        .then(() => {
            localStorage.setItem('inCart', 'false')
            fetch(window.Shopify.routes.root + "?sections=cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer")
                .then(response => response.text())
                .then((responseText) => {
                    const parsedState = JSON.parse(responseText);
                    const elementToReplaceDrawer = document.getElementById("CartDrawer").querySelector(".drawer__inner") || document.getElementById("CartDrawer");
                    const elementToReplaceBuble = document.getElementById("cart-icon-bubble").querySelector(".shopify-section") || document.getElementById("cart-icon-bubble");

                    elementToReplaceDrawer.innerHTML = getSectionInnerHTML(
                        parsedState['cart-drawer'],
                        '.drawer__inner'
                    );
                    elementToReplaceBuble.innerHTML = getSectionInnerHTML(
                        parsedState['cart-icon-bubble'],
                        '.shopify-section'
                    );
                    if (document.getElementById("main-cart-items")) {
                        const elementToReplaceCart = document.getElementById('MainContent').querySelector(".shopify-section");
                        elementToReplaceCart.innerHTML = getSectionInnerHTML(
                            parsedState['main-cart-items'],
                            '.shopify-section'
                        );
                    }
                    
                    // Initialize order count directly after DOM update
                    const initOrderCount = () => {
                        if (typeof window.initializeOrderCount === 'function') {
                            window.initializeOrderCount();
                        } else {
                            // Fallback: Initialize manually if function not loaded yet
                            const container = document.querySelector('.cart-drawer__order-count');
                            const textElement = container?.querySelector('.order-count-text');
                            if (container && textElement && textElement.innerHTML.includes('{count}')) {
                                const minCount = parseInt(container.dataset.countFrom, 10) || 15;
                                const maxCount = parseInt(container.dataset.countTo, 10) || 50;
                                const textTemplate = container.dataset.countText || '{count} Bestellungen in den letzten 24 Stunden';
                                
                                const existingCount = sessionStorage.getItem('orderCount');
                                let orderCount;
                                if (!existingCount) {
                                    orderCount = Math.floor(Math.random() * (maxCount - minCount + 1)) + minCount;
                                    sessionStorage.setItem('orderCount', orderCount.toString());
                                } else {
                                    orderCount = parseInt(existingCount, 10);
                                }
                                
                                const finalText = textTemplate.replace('{count}', orderCount);
                                textElement.innerHTML = finalText;
                            }
                        }
                    };
                    
                    requestAnimationFrame(() => {
                        initOrderCount();
                        
                        // Re-initialize gamification variant after cart update
                        if (typeof window.toggleGamificationVariant === 'function') {
                            window.toggleGamificationVariant();
                        }
                    });
                })
        })
        .finally(() => {
            isUpdating = false;
        })
}

function addGift(item) {
    if(isUpdating) return;
    isUpdating = true;
    // update cart
    fetch(`/cart/add.js`, {
        body: JSON.stringify({
            items: item,
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
        },
    })
        .then((response) => response.text())
        .then(() => {
            localStorage.setItem('inCart', 'true')
            fetch(window.Shopify.routes.root + "?sections=cart-drawer,main-cart-items,cart-icon-bubble")
                .then(response => response.text())
                .then((responseText) => {
                    const parsedState = JSON.parse(responseText);
                    const elementToReplaceDrawer = document.getElementById("CartDrawer").querySelector(".drawer__inner") || document.getElementById("CartDrawer");
                    const elementToReplaceBuble = document.getElementById("cart-icon-bubble").querySelector(".cart-count-bubble") || document.getElementById("cart-icon-bubble");

                    elementToReplaceDrawer.innerHTML = getSectionInnerHTML(
                        parsedState['cart-drawer'],
                        '.drawer__inner'
                    );
                    elementToReplaceBuble.innerHTML = getSectionInnerHTML(
                        parsedState['cart-icon-bubble'],
                        '.cart-count-bubble'
                    );
                    if (document.getElementById("main-cart-items")) {
                        const elementToReplaceCart = document.getElementById("main-cart-items");
                        elementToReplaceCart.innerHTML = getSectionInnerHTML(
                            parsedState['main-cart-items'],
                            '#main-cart-items'
                        );

                    }
                    
                    // Initialize order count directly after DOM update
                    const initOrderCount = () => {
                        if (typeof window.initializeOrderCount === 'function') {
                            window.initializeOrderCount();
                        } else {
                            // Fallback: Initialize manually if function not loaded yet
                            const container = document.querySelector('.cart-drawer__order-count');
                            const textElement = container?.querySelector('.order-count-text');
                            if (container && textElement && textElement.innerHTML.includes('{count}')) {
                                const minCount = parseInt(container.dataset.countFrom, 10) || 15;
                                const maxCount = parseInt(container.dataset.countTo, 10) || 50;
                                const textTemplate = container.dataset.countText || '{count} Bestellungen in den letzten 24 Stunden';
                                
                                const existingCount = sessionStorage.getItem('orderCount');
                                let orderCount;
                                if (!existingCount) {
                                    orderCount = Math.floor(Math.random() * (maxCount - minCount + 1)) + minCount;
                                    sessionStorage.setItem('orderCount', orderCount.toString());
                                } else {
                                    orderCount = parseInt(existingCount, 10);
                                }
                                
                                const finalText = textTemplate.replace('{count}', orderCount);
                                textElement.innerHTML = finalText;
                            }
                        }
                    };
                    
                    // Try immediately, with minimal fallback
                    requestAnimationFrame(() => {
                        initOrderCount();
                        
                        // Re-initialize gamification variant after cart update
                        if (typeof window.toggleGamificationVariant === 'function') {
                            window.toggleGamificationVariant();
                        }
                    });
                })

        }
        )
        .finally(() => {
            isUpdating = false;
        })
}

function getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
}